import * as React from 'react';
import { ICalloutProps } from './callout-types';
import { CalloutContent } from './callout-content';

interface ICalloutState {
    isCalloutVisible: boolean;
}

export class Callout extends React.PureComponent<ICalloutProps, ICalloutState> {
    static getDerivedStateFromProps(props: ICalloutProps) {
        const { hidden } = props;
        if (hidden !== undefined) {
            return { isCalloutVisible: !hidden };
        }
        return null;
    }

    constructor(props: ICalloutProps) {
        super(props);
        this.state = {
            isCalloutVisible: !props.hidden
        };
    }

    render() {
        const { isCalloutVisible } = this.state;
        return (
            isCalloutVisible ? (
                <CalloutContent {...this.props} onDismiss={this.onDismiss} />
            ) : null
        );
    }

    private onDismiss = () => {
        const { onDismiss, preventDismissOnFocusOut, hidden } = this.props;
        if (preventDismissOnFocusOut === true) {
            return;
        }
        if (onDismiss !== undefined) {
            onDismiss();
        }
        if (hidden === undefined) {
            this.setState({
                isCalloutVisible: false
            });
        }
    }
}
